import {API_HOST, API_PORT, API_PREFIX} from "./constants";

export const buildUrl = (endpoint) => `https://${API_HOST}:${API_PORT}${API_PREFIX}${endpoint}`;
export const buildFileUrl = (endpoint) => `https://${API_HOST}:${API_PORT}${endpoint}`;